module.exports = __webpack_public_path__ + "media/images/emblems/Freimettigen-coat_of_arms-69e1f5180a62e87591ce6d71a09bc528.svg";